import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import logo from "../assets/logo.jpeg";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    "Home",
    "About",
    "Services",
    "Contact",
  ];

  return (
    <nav className="bg-black text-white border-b border-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex justify-between items-center h-20">
          
          {/* Logo */}
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-white flex items-center justify-center rounded-full border-2 border-white">
              <span className="text-black text-lg font-black">⚖</span>
            </div>

            <div>
              <h1 className="text-xl font-black tracking-tight text-white">
                LEGAL LIONS
              </h1>
              <p className="text-xs text-gray-400 font-sans">
                People Association
              </p>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link}
                href={`#${link.toLowerCase()}`}
                className="text-sm font-sans font-light tracking-wide hover:text-gray-300 transition uppercase"
              >
                {link}
              </a>
            ))}

            <button className="bg-white text-black px-6 py-2 font-sans font-bold text-sm hover:bg-gray-200 transition">
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <X size={28} />
            ) : (
              <Menu size={28} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden bg-black border-t border-white pb-5">
            {navLinks.map((link) => (
              <a
                key={link}
                href={`#${link.toLowerCase()}`}
                className="block py-3 text-sm font-sans uppercase border-b border-gray-700 hover:text-gray-300"
              >
                {link}
              </a>
            ))}

            <button className="mt-4 w-full bg-white text-black py-3 font-sans font-bold text-sm">
              Contact
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;